import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        items: '<',
        selectedScormId: '=',
        selectedScormName: '='
    },
    template: `
            <table class="data01" datatable="ng" dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{ 'course.scorm.Name' | translate }}</th>
                        <th>{{ 'course.scorm.Date uploaded' | translate }}</th>
                        <th>{{ 'course.scorm.Used in courses' | translate }}</th>
                    </tr>
                </thead>
                <tbody class="ui-selectable">
                    <tr ng-repeat="item in vm.items">
                        <td>
                            <input type="radio" name="r03" ng-change="vm.setName(item)" ng-model="vm.selectedScormId" value="{{ item.id }}">
                        </td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.createdAt * 1000 | date : 'dd.MM.yyyy' }}</td>
                        <td>{{ vm.getUsedInCourses(item) ? vm.getUsedInCourses(item) : '-'}}</td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
    `
})
export default class {
    constructor (DATATABLES, lodash) {
        this.DATATABLES = DATATABLES;
        this.lodash = lodash;
    }

    getUsedInCourses (item) {
        let courses = [];
        if (item.courses) {
            courses = this.lodash.map(item.courses, (course) => course.activeI18n.name);
            courses = this.lodash.uniq(courses);
        }

        return courses.join(', ');
    }

    setName (item) {
        this.selectedScormName = item.name;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/scorm/table/index.js